import React from 'react'

import { config } from 'config/config.js';
import { connect } from 'react-redux';
import { onClientSide, sendDispatchEvent } from 'utils/utils';

import { cleanString, removeAccents, returnStateShort } from 'utils/utils'
import './AutoComplete.scss';

let timeout;
let searchDelay = 250;
let justPressedKey = false
let dontOpenResults = false

class AutoComplete extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			openResults: false,
			inputValue: null,
			lastValidResult: '',
			fetching: false
		};
		this.handleBGClick = this.handleBGClick.bind(this)
	}
	componentDidMount() {
		this.resetSearch()
		if (onClientSide()) {
			window.addEventListener('click', this.handleBGClick, false)
		}
	}
	componentWillUnmount() {
		// this.props.dispatch( fetchModal(false) )
		this.setState({ modalOpen: false })
		if (onClientSide()) {
			window.removeEventListener('click', this.handleBGClick, false)
		}
	}
	componentDidUpdate(prevProps) {
		if (this.props.value != prevProps.value) {
			this.setState({
				inputValue: this.props.value,
				openResults: false
			})
			this.resetSearch()
		}
	}
	fetchSearch() {
		if (!dontOpenResults) {
			timeout && clearTimeout(timeout)
			timeout = setTimeout(function () {
				this.setState({
					inputValue: this.refs.autoCompleteInput.value,
					openResults: true
				})
				// 	this.props.dispatch( fetchSearch(this.refs.autoCompleteInput.value) )
			}.bind(this), searchDelay)
		} else {

		}
	}
	handleInput() {
		this.props.callBack(this.refs.autoCompleteInput.value, false)
		if (this.refs.autoCompleteInput.value.length > 1) {
			this.fetchSearch()
		} else {
			this.setState({
				openResults: false,
				inputValue: null,
				fetching: true
			})
		}
	}
	forceFocusChange(e, direction) {
		e.preventDefault()
		let results = document.getElementsByClassName('AutoComplete-result')

		if (results) {
			if (this.refs.autoCompleteInput == document.activeElement && results[0]) {
				direction ? results[0].focus() : results[results.length - 1].focus()
			} else {
				for (let i = 0; i < results.length; i++) {
					if (results[i] == document.activeElement) {
						let focusOn = results[i + (direction ? 1 : -1)]
						focusOn ? focusOn.focus() : this.refs.autoCompleteInput.focus()
						return false
					}
				}
			}
		}
	}
	handleKeyDown(e) {
		justPressedKey = true
		switch (e.keyCode) {
			case 13: // esc
				if (e.target && e.target.getAttribute('data-value')) {
					this.setResult(
						{
						name: e.target.getAttribute('data-value'),
					 	latitude : e.target.getAttribute('data-latitude'),
						longitude:   e.target.getAttribute('data-longitude'),
						raio:   e.target.getAttribute('data-raio')
					})
				}
				break;
			case 27: // esc
				this.refs.autoCompleteInput.blur()
				this.handleClickResult()
				break;
			case 40: // down
				this.forceFocusChange(e, 1)
				break;
			case 39: // right
				e.target.click()
				break;
			case 38: // up
				this.forceFocusChange(e, 0)
				break;
			case 48: case 49: case 50: case 51: case 52: case 53: case 54: case 55: case 56: case 57: case 65: case 66: case 67: case 68: case 69: case 70: case 71: case 72: case 73: case 74: case 75: case 76: case 77: case 78: case 79: case 80: case 81: case 82: case 83: case 84: case 85: case 86: case 87: case 88: case 89: case 90: // go back to input when user starts typing again
				if (this.props.value == this.props.lastValid) {
					this.refs.autoCompleteInput.value = ''
				}
				if (this.state.openResults && this.refs.autoCompleteInput != document.activeElement) {
					this.refs.autoCompleteInput.focus()
				}
				break;
		}
		justPressedKey = false
	}
	handleClickResult() {
		// submitSatellite('searchClick')
		this.resetSearch()
	}
	resetSearch(dontClearField) {
		if (!dontClearField) {
			this.refs.autoCompleteInput.value = this.props.value
			this.setState({ inputValue: this.props.value })
		}
		this.setState({ openResults: false })
	}
	clearSearch() {
		if(onClientSide()){
			window.sessionStorage.setItem('shouldNotForceLocation', true)
      sendDispatchEvent("limparCampoLocalizacaoRB")
		}
		this.setResult(this.props.blankResult ? this.props.blankResult : '')
	}
	renderBold(resultString) {
		let regex = new RegExp(/([\s\_\-]+)/)
		let resultArr = resultString.split(regex)
		let inputArr = this.state.inputValue.split(regex)
		let normResultArr = []
		let normInputArr = []
		for (let i = 0; i < resultArr.length; i++) {
			resultArr[i] && normResultArr.push(removeAccents(resultArr[i]).toLowerCase())
		}
		for (let i = 0; i < inputArr.length; i++) {
			inputArr[i] && normInputArr.push(removeAccents(inputArr[i]).toLowerCase())
		}
		for (let i = 0; i < normInputArr.length; i++) {
			if (normInputArr[i].trim().length > 1 && cleanString(normInputArr[i], { toLowerCase : 1, removeAccents : 1, wordOnly : 1 }) != '') {
				for (let ii = 0; ii < normResultArr.length; ii++) {
					let testCheck = false
					normResultArr[ii].includes(normInputArr[i]) && (testCheck = normResultArr[ii].split(normInputArr[i]))
					testCheck && testCheck.splice(1, 0, normInputArr[i])
					if (testCheck) {
						let testResult = []
						let pointer = 0
						for (let iii = 0; iii < testCheck.length; iii++) {
							let spaceChar = ''

							if (new RegExp( testCheck[iii].replace(/([^A-zÀ-ú])/g, '\\$') + '$1').test(normResultArr[ii])) {
								spaceChar = " "
							}
							if (!Array.isArray(resultArr[ii])) {
								testResult.push(resultArr[ii].substr(pointer, testCheck[iii].length) + spaceChar)
								pointer += testCheck[iii].length
							}
						}
						testResult.length && (testResult[1] = (<strong key={'renderBoldAutoComplete' + i + '-' + ii}>{testResult[1]}</strong>))
						testResult.length && (resultArr[ii] = testResult)
					}
				}
			}
		}
		return resultArr
	}
	contains(string, substring) {
		let regex = new RegExp(/([\s\_]+)/)
		// let regex = new RegExp(/([\s\_\-\/]+)/)
		let resultArr = substring.split(regex)
		for (let i = 0; i < resultArr.length; i++) {
			if (resultArr[i].trim().length && cleanString(resultArr[i], { toLowerCase : 1, removeAccents : 1, wordOnly : 1 }) != '') {
				if (!cleanString(string, { toLowerCase : 1, removeAccents : 1, wordOnly : 1 }).includes(cleanString(resultArr[i], { toLowerCase : 1, removeAccents : 1, wordOnly : 1 }))) {
					return false
				}
			}
		}
		return true
	}
	setResult(value) {
		// this.setState({ lastValidResult : value },
		// 	() => {

		// setTimeout(() => {

		if (this.props.callBack) {
			this.props.callBack(value, true)
			// this.refs.autoCompleteInput.value = value
			this.resetSearch(true)
		}
		// }, 1);
		// }
		// )
	}
	checkValidity() {
		setTimeout(() => {
			if (!justPressedKey && this.props.value != this.props.lastValid) {
				dontOpenResults = true
				this.setResult(this.props.blankResult ? this.props.blankResult : '')
				dontOpenResults = false
			} else if (this.props.value === "" && this.props.lastValid === "") {
				this.setResult(this.props.blankResult ? this.props.blankResult : '')
			}
		}, 0);
	}

	handleBlur() {
		if (!this.state.openResults) {
			this.checkValidity()
		}
	}
	handleResultClick(value) {
    window.sessionStorage.setItem('shouldNotForceLocation', true)
		this.setResult(value)
	}
	modelResult(obj, img, url, key) {
		return (
			<div key={key} tabIndex={0}
				className='AutoComplete-result'
				onMouseOver={this.handleMouseOver.bind(this)}
				onKeyDown={this.handleKeyDown.bind(this)}
				onClick={this.handleResultClick.bind(this, {name:obj.name ,latitude:obj.latitude,longitude:obj.longitude,'raio':obj.raio})}
				data-value={obj.name}
				data-latitude={obj.latitude}
				data-longitude={obj.longitude}
				data-raio={obj.raio}
			>
				<div className='AutoComplete-result-name'>
					{this.renderBold(obj.name)}
				</div>
				<div className='AutoComplete-result-arrow'>
					<span className="icon-right" />
				</div>
			</div>
		)
	}
	makeResult(name, img, url, key) {
		return (
			<div key={key} tabIndex={0}
				className='AutoComplete-result'
				onMouseOver={this.handleMouseOver.bind(this)}
				onKeyDown={this.handleKeyDown.bind(this)}
				onClick={this.handleResultClick.bind(this, name)}
				data-value={name}
			>
				<div className='AutoComplete-result-name'>
					{this.renderBold(name)}
				</div>
				<div className='AutoComplete-result-arrow'>
					<span className="icon-right" />
				</div>
			</div>
		)
	}
	handleMouseOver(e) {
		e.target.focus()
	}
	renderResults() {
		if (this.props.source) {
			return (
				<div className='AutoComplete-results'>
					{this.results()}
				</div>
			)
		} else {
			return ""
		}
	}
	renderResultGroup(title, results, key) {
		return (
			<div key={key} className={'AutoComplete-result-group' + (title == "Marcas" ? " brand-result-group" : "")}>
				<div className="AutoComplete-group-title">{title}</div>
				{results}
			</div>
		)
	}
	results() {


		let makes = []
		let models = []
		// let versions = []
		let searchResults = this.props.source

		for (let makeIndex = 0; makeIndex < searchResults.length; makeIndex++) {
			let makeName = searchResults[makeIndex].name
			let makeLink = '/' + this.props.vehicleRoute + '/estoque/' + cleanString(searchResults[makeIndex].name, { toLowerCase : 1, removeAccents : 1, removeDots : 1, slugify : 1 } )
			let makeImg = config.makeLogoCatalogo + cleanString(makeName, { toLowerCase : 1, removeAccents : 1, wordOnly : 1 }) + ".png?t=" + config.randomUrl
			let makeKey = 'make' + makeIndex + cleanString(makeName, { toLowerCase : 1, removeAccents : 1, wordOnly : 1 })
			if (this.contains(makeName, this.state.inputValue)) {
				makes.push(this.makeResult(makeName, makeImg, makeLink, makeKey))
			}
			for (let modelIndex = 0; modelIndex < searchResults[makeIndex].items.length; modelIndex++) {

				let modelName = searchResults[makeIndex].items[modelIndex].name + " - " + returnStateShort(searchResults[makeIndex].name)
				let modelImg = ''
				let modelLink = '/' + this.props.vehicleRoute +
				 '/estoque/' + cleanString(searchResults[makeIndex].name, { toLowerCase : 1, removeAccents : 1, removeDots : 1, slugify : 1 } ) + '/'
				 + cleanString(searchResults[makeIndex].items[modelIndex].name, { toLowerCase : 1, removeAccents : 1, removeDots : 1, slugify : 1 } )

				//  if(searchResults[makeIndex].items[modelIndex].latitude && searchResults[makeIndex].items[modelIndex].longitude) {
				// 	modelLink+=`localizacao=${searchResults[makeIndex].items[modelIndex].latitude},${searchResults[makeIndex].items[modelIndex].longitude}x${100}km`
				//  }

				let modelKey = 'model' + modelIndex + cleanString(modelName, { toLowerCase : 1, removeAccents : 1, wordOnly : 1 })
				if (this.contains(modelName, this.state.inputValue)) {
					models.push(this.modelResult({ name:modelName,
						latitude :searchResults[makeIndex].items[modelIndex].latitude,
						longitude :searchResults[makeIndex].items[modelIndex].longitude,
						raio:searchResults[makeIndex].items[modelIndex].raio}, modelImg, modelLink, modelKey))
				}
			}
		}
		let resultsLeft = 5

		if (resultsLeft) {
			makes = makes.slice(0, resultsLeft)
			resultsLeft -= makes.length
			makes.length ? makes = this.renderResultGroup('Estados', makes, 'makesGroup') : makes = undefined
		}

		if (resultsLeft) {
			models = models.slice(0, resultsLeft)
			resultsLeft -= models.length
			models.length ? models = this.renderResultGroup('Cidades', models, 'modelsGroup') : models = undefined
		} else {
			models = []
		}

		if (models == undefined && makes == undefined) {
			return <div className="AutoComplete-result no-result">Não encontramos este termo, verifique a ortografia</div>
		}

		let result = [makes, models]
		return result;
	}
	handleBGClick(e) {
		if ((this.refs.autoCompleteInput == document.activeElement || this.state.openResults) && !this.refs.autoCompleteContainer.contains(e.target)) {
			(this.props.value != this.props.lastValid) && this.setResult((this.props.blankResult ? this.props.blankResult : ''))
			e.preventDefault();
			this.resetSearch(this.props.noModal)
			if (this.state.openResults) {
				this.checkValidity()
			}
		}
	}
	handleFocus(e) {
		if (this.props.responsive.result.browser == 'android' && this.props.parentScrollContainer) {
			let scrollTo = this.props.parentScrollContainer.scrollTop + this.refs.autoCompleteInput.getBoundingClientRect().top - 60
			if (this.refs.autoCompleteInput.getBoundingClientRect().top > 130 || this.refs.autoCompleteInput.getBoundingClientRect().top < 10) {
				this.props.parentScrollContainer.scrollTop = scrollTo
			}
		}
	}
	handleIconClick() {
		if (this.refs.autoCompleteInput.value) {
			this.setResult("")
		}
	}
	renderClear() {
		return (<div ref='AutoCompleteIcon' className={"AutoComplete__icon" + (this.refs.autoCompleteInput && this.refs.autoCompleteInput.value != (this.props.blankResult ? this.props.blankResult : '') ? " AutoComplete__icon--close" : "")} onClick={this.clearSearch.bind(this)} />)
	}
	renderInput() {
		return (
			<div className={'AutoComplete-input-container Form__field '}>
				<input
          data-qa={this.props.dataQA || undefined}
					type='text'
					className={
						(this.refs.autoCompleteInput && this.refs.autoCompleteInput.value && this.refs.autoCompleteInput.value.length ? " Form__field__filled" : "")
						+ (this.state.openResults && this.refs.autoCompleteInput.value.length ? ' is--filled' : '')
						+ (this.state.openResults ? ' results--open' : '')
					}
					ref="autoCompleteInput"
					onFocus={(e) => { this.handleFocus(e) }}
					onChange={this.handleInput.bind(this)}
					onBlur={this.handleBlur.bind(this)}
					onKeyDown={this.handleKeyDown.bind(this)}
					id={this.props.id ? this.props.id : ""}
					autoComplete="off"
				/>
				<label className="Form__field__label">{this.props.placeholder ? this.props.placeholder : ''}</label>
				{this.state.openResults && this.refs.autoCompleteInput.value ? this.renderResults() : <span />}
			</div>
		)
	}
	renderModal() {
		// if (this.state.modalOpen) {
		// 	return <ModalContainer onBgClick={this.resetSearch.bind(this, false)} show={true} />
		// }
		return false
	}
	render() {
		return (
			<div
				ref='autoCompleteContainer'
				className={
					'AutoComplete'
					+ (this.props.disabled ? ' is--disabled' : '')
					+ (this.props.lastValidResult ? ' is--filled' : '')
				}
			>
				{this.renderInput()}
				{this.renderClear()}
			</div>
		)
	}
}
export default connect((store) => {
	return {
		responsive: store.responsiveState
	};
})(AutoComplete);
